export default function formatDate(value: string) {
  if (!value || value === null) {
    return ''
  } else {
    return new Intl.DateTimeFormat('pt-BR').format(new Date(value))
  }

}